export default __webpack_public_path__ + "static/media/simple.cafcdd25.jpg";